export const exportTypes = [
  { value: 'quickbooks-local', label: 'Excel .xlsx (QuickBooks)' },
  { value: 'viewpoint', label: 'Export (Cyma, Vista, Keystone, etc)' },
  { value: 'spectrum', label: 'Export (Spectrum)' },
];
